namespace Matrix.Data {
    export interface SecurityRelationshipRow {
        SecurityId?: number;
        RelatedSecurityId?: number;
        RelationshipTypeCode?: string;
        Status?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        SecurityCode?: string;
        SecurityName?: string;
        SecurityRowId?: number;
        RelatedSecurityCode?: string;
        RelatedSecurityName?: string;
        RelatedSecurityRowId?: number;
        RelationshipTypeName?: string;
        RelationshipGroup?: string;
        RelationshipTypeStatus?: string;
        RelationshipTypeRowId?: number;
    }

    export namespace SecurityRelationshipRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Data.SecurityRelationship';
        export const deletePermission = 'DataAdmin:SecurityRelationship';
        export const insertPermission = 'DataAdmin:SecurityRelationship';
        export const readPermission = 'Read:Security';
        export const updatePermission = 'DataAdmin:SecurityRelationship';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            RelatedSecurityId = "RelatedSecurityId",
            RelationshipTypeCode = "RelationshipTypeCode",
            Status = "Status",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            SecurityCode = "SecurityCode",
            SecurityName = "SecurityName",
            SecurityRowId = "SecurityRowId",
            RelatedSecurityCode = "RelatedSecurityCode",
            RelatedSecurityName = "RelatedSecurityName",
            RelatedSecurityRowId = "RelatedSecurityRowId",
            RelationshipTypeName = "RelationshipTypeName",
            RelationshipGroup = "RelationshipGroup",
            RelationshipTypeStatus = "RelationshipTypeStatus",
            RelationshipTypeRowId = "RelationshipTypeRowId"
        }
    }
}
